import { type FunctionComponent } from 'react';
import { Routes, Route } from 'react-router-dom';
import { useScrollPositionHandler } from '../hooks/routing/scroll-position-handler.hook';
import { generatedRoutes } from '../routes/generated-routes';
import { ApplicationObserver } from './layouts/application-observer/application-observer.component';
import { RouteWithLayout } from './layouts/routed/routed-with-layout.component';
import '../styles/global.css';

export const App: FunctionComponent = () => {
	useScrollPositionHandler();
	const appRoutes = generatedRoutes.map((props) => {
		const path = props.path;
		return <Route path={path} key={props.path} element={<RouteWithLayout {...props} />}></Route>;
	});
	return (
		<ApplicationObserver>
			<Routes>{appRoutes}</Routes>
		</ApplicationObserver>
	);
};
